import React from 'react'
import { TouchableOpacity } from 'react-native'
import { commonColors } from '@linqpal/common-frontend/src/theme'

export const GetIcon = ({ icon, onPress, style = {}, testID = '' }) => {
  return (
    <TouchableOpacity
      style={{
        height: 40,
        width: 40,
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: commonColors.backgroundLight,
        borderRadius: 8,
        ...style,
      }}
      onPress={onPress}
      testID={testID}
    >
      {icon}
    </TouchableOpacity>
  )
}
